var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfigManagementActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.03,
    height: 31.989,
    viewBox: "0 0 39.03 31.989",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#2A7DE1;}.b{stroke:#006aa6;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.32 -407)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M27.08,17.9a11.819,11.819,0,0,0,.091-1.412,8.931,8.931,0,0,0-.109-1.412l3.06-2.39a.748.748,0,0,0,.181-.924l-2.9-5.016a.736.736,0,0,0-.887-.326l-3.6,1.449a10.609,10.609,0,0,0-2.445-1.412l-.543-3.839A.723.723,0,0,0,19.2,2H13.409a.7.7,0,0,0-.706.616l-.543,3.839A10.893,10.893,0,0,0,9.715,7.867l-3.6-1.449a.716.716,0,0,0-.887.326l-2.9,5.016a.7.7,0,0,0,.181.924l3.06,2.39A8.534,8.534,0,0,0,5.55,17.9l-3.06,2.39a.748.748,0,0,0-.181.924l2.9,5.016a.736.736,0,0,0,.887.326l3.6-1.449a10.609,10.609,0,0,0,2.445,1.412l.543,3.839a.737.737,0,0,0,.724.616H19.2a.692.692,0,0,0,.706-.616l.543-3.839A10.893,10.893,0,0,0,22.9,25.106l3.6,1.449a.716.716,0,0,0,.887-.326l2.9-5.016a.7.7,0,0,0-.181-.924L27.08,17.9Zm-10.774,4.02a5.432,5.432,0,1,1,5.432-5.432A5.448,5.448,0,0,1,16.306,21.919Z",
    transform: "translate(-51.542 405)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-31.265 411.854)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 10.182,
    height: 12.728,
    rx: 5.091,
    transform: "translate(5.091)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.113,0A10.113,10.113,0,0,1,20.225,10.113c0,3.163-20.225,2.932-20.225,0A10.113,10.113,0,0,1,10.113,0Z",
    transform: "translate(0 13.986)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigManagementActive);
export default __webpack_public_path__ + "static/media/configManagementActive.ccbcdc71b5d86a6b91d51b12b65a3641.svg";
export { ForwardRef as ReactComponent };